import createVueApp from '@phoenix/createVueApp';
import GuestOrderTokenRequestModal from '@maison/components/form/GuestOrderTokenRequestModal.vue';

const app = createVueApp({}, true);
app.component('GuestOrderTokenRequestModal', GuestOrderTokenRequestModal);
app.mount('#phoenix-guest-order-token-request-modal');
